import { connect } from 'react-redux';
import { decorateWith, withName } from 'helpers/decorator';
import { removeCmsBanner } from './Banners.reducer';
import { CmsBanner } from './CmsBanner';

export const mapStateToProps = (
  state,
  { action, pagesWithBannerDisabled = [], pagesWithBannerActionDisabled = [], path }
) => {
  const pathIncludesDisabledPage = pagesWithBannerDisabled.some(page => path.includes(page));
  const pathIncludesDisabledAction = pagesWithBannerActionDisabled.some(page => path.includes(page));
  return {
    shouldRemoveBannerFromPage: pathIncludesDisabledPage,
    shouldShowActionOnPage: action && !pathIncludesDisabledAction,
  };
};

const mapDispatchToProps = {
  onBannerClose: removeCmsBanner,
};

export const CmsBannerContainer = decorateWith(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withName('CmsBanner')
)(CmsBanner);
